import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MessageToastService {

  constructor(private toastr: ToastrService) { }

  private processAndShow(
    type: 'success' | 'error' | 'warning' | 'info',
    messages: string[] = [],
    extraMessage?: string
  ): void {
    const msgs = [...messages];
    if (extraMessage) {
      msgs.unshift(extraMessage);
    }
    
    if (msgs.length === 0) return;

    msgs.forEach(msg => {
      switch (type) {
        case 'success': this.toastr.success(msg); break;
        case 'error': this.toastr.error(msg); break;
        case 'warning': this.toastr.warning(msg); break;
        case 'info': this.toastr.info(msg); break;
        default: this.toastr.show(msg); break;
      }
    });
  }
  public success(messages: string[] = [], extraMessage?: string): void {
    this.processAndShow('success', messages, extraMessage);
  }

  public error(messages: string[] = [], extraMessage?: string): void {
    this.processAndShow('error', messages, extraMessage);
  }

  public warning(messages: string[] = [], extraMessage?: string): void {
    this.processAndShow('warning', messages, extraMessage);
  }

  public info(messages: string[] = [], extraMessage?: string): void {
    this.processAndShow('info', messages, extraMessage);
  }
}